/* eslint-disable no-unused-vars */
import React, { forwardRef, useId, useEffect, useContext } from 'react';
import { useSignal, useComputed } from '@preact/signals-react';
import { CustomInput, Buttons, Label } from 'components';
import { DeleteIcon } from 'assets/icons';
import { showPolipop } from 'utils';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import { ManageCampaignsContext } from 'contexts';

const getAllCmNames = (data, currentCampId) => {
  return data.campaignsData
    .filter(({ campaignId }) => campaignId !== currentCampId)
    .map(({ campaign }) => campaign);
};

export const ChangeCampaignNameTooltip = forwardRef((props, ref) => {
  const inputId = useId();
  const campaignName$ = useSignal(props.campaignName);
  const { campaignData$, updateTableData } = useContext(ManageCampaignsContext);
  const [changeNameAction, result] = saveCampaignServiceAPI.useUpdateCampaignNameMutation();
  const isType$ = useSignal(false);
  const allCm_name$ = useComputed(() => getAllCmNames(campaignData$.value, props.campaignId));

  const saveNewName = async () => {
    const res = await changeNameAction({
      cm_id: props.campaignId,
      name: campaignName$.value,
    });
  };

  useEffect(() => {
    if (result.isSuccess || result.isError) {
      showPolipop(result);
    }
    if (result.isSuccess) {
      updateTableData({
        newValue: campaignName$.value,
        fieldName: 'campaign',
        campId: props.campaignId,
      });
      props.isOpen$.value = false;
    }
  }, [result]);

  const okBtnIsDisabled$ = useComputed(() => {
    if (!campaignName$.value) return true;
    //if (campaignName$.value === props.campaignName) return true;
    if (allCm_name$.value.includes(campaignName$.value)) return true;
    return false;
  });

  const isError$ = useComputed(() => {
    if (!isType$.value) return false;
    return okBtnIsDisabled$.value;
  });

  return (
    <div ref={ref} style={{ padding: '16px' }}>
      <Label text='Change Name:' variant='label' style={{ marginBottom: '8px' }} />
      <CustomInput
        onChange={(e) => {
          const newValue = e.target.value;
          if (newValue.length <= 100) {
            campaignName$.value = newValue;
            isType$.value = true;
          }
        }}
        id={inputId}
        name={inputId}
        value={campaignName$.value}
        width={377}
        rightIcon={<DeleteIcon />}
        rightIconOnClick={() => {
          campaignName$.value = '';
        }}
        autoComplete='off'
        error={isError$.value}
        errorText='This field is required and it should be unique'
      />
      <div
        style={{ display: 'flex', gap: '16px', marginTop: '16px', justifyContent: 'space-around' }}
      >
        <Buttons.SecondaryNormal
          id='close-changeName-tooltip'
          onClick={() => {
            props.isOpen$.value = false;
          }}
          isDisabled={result.isLoading}
          style={{ width: '100%' }}
        >
          Cancel
        </Buttons.SecondaryNormal>
        <Buttons.PrimaryNormal
          id='save-changeName-tooltip'
          onClick={saveNewName}
          isDisabled={okBtnIsDisabled$.value || result.isLoading}
          style={{ width: '100%' }}
        >
          Ok
        </Buttons.PrimaryNormal>
      </div>
    </div>
  );
});

ChangeCampaignNameTooltip.displayName = 'ChangeCampaignNameTooltip';
